export const EVENTS = {
	CHANGE: 'CHANGE'
};